export function checkIsMobileDevice(userAgent: string | undefined): boolean {
  if (!userAgent) return false;

  const normalized = userAgent.toLowerCase();
  const isMobileAgent =
    /mobile|android|iphone|ipad|ipod|tablet|blackberry|iemobile|opera mini/.test(normalized);

  if (isMobileAgent) {
    return true;
  }

  if (typeof window !== "undefined") {
    return window.innerWidth <= 1024;
  }

  return false;
}
